import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import Button from '../common/form/button';
import Grid from '../common/layout/grid';
import Checkbox from '../common/form/checkbox';

import { init, sendForced, sendForcedSemSalvar, sendCancelForced } from './planoForcadoAction';

import SelectAllControlador from '../common/selectdb/selectAllControlador';
import SelectPlano from '../common/selectdb/selectPlano';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndSelectForm from '../common/form/labelAndSelectForm';
import { toastr } from 'react-redux-toastr';
import { Modal } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import configLocal from '../configuracao/configLocal';
import PermissaoUsuario from '../auth/permissao';
import swal from 'sweetalert2';
import html2canvas from 'html2canvas';
import { getPlanoList, getControladorGrupoList } from '../common/selectdb/selectdbAtions';
import { getPlanosAgendados } from './planoForcadoAction';
import SelectAllGrupoFisico from '../common/selectdb/SelectAllGrupoFisico';
import axiosInstance from '../main/axios';

class PlanoForcadoForm extends Component {
  constructor(props) {
    super(props);

    this.componentRef = React.createRef();

    this.state = {
      grupoFisicoId: '', // Inicia vazio para mostrar "Selecione"
      configContId: configLocal.getConfig('cont'),
      contId: '0',
      planoId: 0,
      horaIni: 0,
      horaFin: 0,
      show: false,
      planosAgendados: [],
    };
    this.sendForcedPlan = this.sendForcedPlan.bind(this);
    this.sendCancelForcedPlan = this.sendCancelForcedPlan.bind(this);
    this.handleChangePlano = this.handleChangePlano.bind(this);
    this.carregarPlanosAgendados = this.carregarPlanosAgendados.bind(this);
    this.resetTelaPlanoForcado = this.resetTelaPlanoForcado.bind(this);
  }

  carregarPlanosAgendados(contId) {
    if (contId && parseInt(contId) > 0) {
      return this.props.getPlanosAgendados(contId).then(result => {
        this.setState({ planosAgendados: result.payload.data || [] });
        return result;
      });
    }

    this.setState({ planosAgendados: [] });
    return Promise.resolve();
  }

  resetTelaPlanoForcado() {
    this.setState({
      grupoFisicoId: '',
      contId: '0',
      planoId: 0,
      horaIni: 0,
      horaFin: 0,
      planosAgendados: [],
    });

    this.props.change('plano_id', '0');
    this.props.change('horario_inicial', '');
    this.props.change('horario_final', '');
    this.props.change('anel1', false);
    this.props.change('anel2', false);
    this.props.change('anel3', false);
    this.props.change('anel4', false);

    if (this.props.valores) {
      this.props.valores.grupoFisicoId = '';
      this.props.valores.contId = '0';
      this.props.valores.pf_anel = 1;
    }

    this.props.getControladorGrupoList('0');
    this.props.getPlanoList('0');
  }

  getTextoStatusPlano(plano) {
    if (!plano || !plano.horario_inicial || !plano.horario_final) return '';

    const agora = new Date();
    const [hIni, mIni, sIni] = plano.horario_inicial.split(':').map(v => parseInt(v || '0', 10));
    const [hFim, mFim, sFim] = plano.horario_final.split(':').map(v => parseInt(v || '0', 10));

    const inicio = new Date();
    inicio.setHours(hIni, mIni, sIni || 0, 0);

    const fim = new Date();
    fim.setHours(hFim, mFim, sFim || 0, 0);

    if (agora >= inicio && agora <= fim) {
      return 'Em execução';
    }

    const diffMs = inicio.getTime() - agora.getTime();
    if (diffMs <= 0) {
      return 'Agendado';
    }

    const totalMin = Math.floor(diffMs / 60000);
    const horas = Math.floor(totalMin / 60);
    const minutos = totalMin % 60;

    if (horas > 0 && minutos > 0) return `Começa em ${horas}h ${minutos}min`;
    if (horas > 0) return `Começa em ${horas}h`;
    return `Começa em ${minutos}min`;
  }

  getAneisTextoPlano(plano) {
    if (!plano) return '';
    const anel = parseInt(plano.anel || 0, 10);

    if (anel === 0) {
      return 'Todos';
    }

    if (parseInt(plano.plano_id, 10) === 63) {
      const aneis = [];
      for (let index = 1; index <= 4; index++) {
        if ((anel & Math.pow(2, index - 1)) > 0) {
          aneis.push(index);
        }
      }

      if (aneis.length === 0) return 'Todos';
      if (aneis.length === 1) return `Anel ${aneis[0]}`;

      // Múltiplos anéis: "Anéis 1, 2 e 3" ou "Anéis 1 e 2"
      const ultimoAnel = aneis.pop();
      return `Anéis ${aneis.join(', ')} e ${ultimoAnel}`;
    }

    return `Anel ${anel}`;
  }

  getDescricaoPlanoCard(plano) {
    if (!plano) return '';
    if (parseInt(plano.plano_id, 10) === 63 && parseInt(plano.plano_tratado || 0, 10) > 0) {
      return `Plano Intermitente ${plano.plano_tratado}`;
    }
    return plano.plano_descricao || `Plano ${plano.plano_id}`;
  }

  validateInitialTime(value) {
    if (!value) return;
    // value may be HH:MM or HH:MM:SS
    const [hStr, mStr, sStr] = value.split(':');
    const h = parseInt(hStr || '0', 10);
    const m = parseInt(mStr || '0', 10);
    const s = parseInt(sStr || '0', 10);

    const now = new Date();
    const minAllowed = new Date(now.getTime() + 10 * 60 * 1000);
    const selected = new Date();
    selected.setHours(h, m, s || 0, 0);

    if (selected < minAllowed) {
      const hh = String(minAllowed.getHours()).padStart(2, '0');
      const mm = String(minAllowed.getMinutes()).padStart(2, '0');
      const ss = '00';
      const adjusted = `${hh}:${mm}:${ss}`;
      this.props.change('horario_inicial', adjusted);
      toastr.warning(
        'Atenção',
        'A hora inicial do plano forcado deve ser pelo menos 10 minutos maior que a hora atual.',
        { position: 'top-right' },
      );
    }
  }

  validateMinTime = value => {
    if (!value) return 'Obrigatório';

    const [hStr, mStr, sStr] = value.split(':');
    const h = parseInt(hStr || '0', 10);
    const m = parseInt(mStr || '0', 10);
    const s = parseInt(sStr || '0', 10);

    const now = new Date();
    const minAllowed = new Date(now.getTime() + 10 * 60 * 1000);
    const selected = new Date();
    selected.setHours(h, m, s || 0, 0);

    if (selected < minAllowed) {
      return 'O horário deve ser pelo menos 10 minutos maior que a hora atual';
    }

    return undefined;
  };

  async handleChangePlano(event) {
    const planoId = event && event.target ? event.target.value : undefined;
    const contId = this.state.contId || (this.props.valores ? this.props.valores.contId : undefined);

    // Atualizar o estado do plano selecionado para controlar as opções do anel
    this.setState({ planoId: planoId });

    // Sempre marcar todos os checkboxes por padrão
    // A diferença é que planos normais ficam desabilitados e intermitente/apagado ficam habilitados
    if (planoId && planoId !== '0') {
      this.props.change('anel1', 1);
      this.props.change('anel2', 1);
      this.props.change('anel3', 1);
      this.props.change('anel4', 1);
    }

    // Não valida quando: sem controlador específico, plano não escolhido, ou intermitente
    if (!planoId || planoId === '0' || planoId === '63' || !contId || parseInt(contId) === 0) {
      return;
    }

    try {
      await axiosInstance.get(`/trocaplanos/validar-plano/${contId}/${planoId}`);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const message = error.response.data.message;
        toastr.error('Plano Inválido', message);
        // Limpa o campo plano
        this.props.change('plano_id', '0');
      } else {
        toastr.error('Erro', 'Erro ao validar plano. Tente novamente.');
      }
    }
  }

  // Processar anéis selecionados antes de enviar (usando bitmap como na troca de plano)
  processarAneisSelecionados() {
    const { planoId } = this.state;
    const isIntermitentOrDeleted = planoId === '63' || planoId === '32';

    console.log('=== PROCESSAR ANEIS ===');
    console.log('planoId:', planoId);
    console.log('isIntermitentOrDeleted:', isIntermitentOrDeleted);
    console.log('valores:', this.props.valores);

    // Se não é intermitente/apagado, retorna 0 (todos os anéis)
    if (!isIntermitentOrDeleted) {
      console.log('Não é intermitente/apagado, retornando 0');
      return 0;
    }

    // Para intermitente/apagado, converter checkboxes para bitmap
    let anelBitmap = 0;
    for (let index = 1; index <= 4; index++) {
      const anelName = 'anel' + index;
      const checked = this.props.valores && this.props.valores[anelName];
      console.log(`${anelName}:`, checked);
      if (checked) {
        anelBitmap += Math.pow(2, index - 1); // 2^0=1, 2^1=2, 2^2=4, 2^3=8
      }
    }

    console.log('anelBitmap calculado:', anelBitmap);

    // Se nenhum anel selecionado, retorna 0 (erro - não deveria acontecer)
    if (anelBitmap === 0) {
      console.log('Nenhum anel selecionado, retornando 0');
      return 0;
    }

    // Para planos intermitentes/apagados, SEMPRE retornar o bitmap calculado
    // mesmo que seja 15 (todos os anéis), pois o backend precisa do valor exato
    console.log('Retornando bitmap:', anelBitmap);
    return anelBitmap;
  }

  sendCancelForcedPlan() {
    this.setState({ show: true });

    // Usar valores do state que ainda estão preenchidos
    const dadosDesativacao = {
      grupoFisicoId: this.state.grupoFisicoId,
      contId: this.state.contId,
      ...this.props.valores,
    };

    this.props
      .sendCancelForced(dadosDesativacao)
      .then(result => {
        if (result.payload.data.success) {
          this.resetTelaPlanoForcado();
          this.setState({ show: false });
          toastr.success('Sucesso', 'Plano forçado desativado com sucesso.');
        } else {
          this.setState({ show: false });
        }
      })
      .catch(e => {
        if (e.response && e.response.data && e.response.data.errors) {
          e.response.data.errors.forEach(error => toastr.error('Erro', ` Atenção: ${error}`));
        } else {
          toastr.error('Erro', 'Erro ao desativar plano forçado.');
        }
        this.setState({ show: false });
      });
  }

  async sendForcedPlan() {
    if (this.props.valid) {
      // Pré-validação: se um controlador específico foi escolhido, validar plano em todos os anéis
      try {
        const contId = this.state.contId || (this.props.valores ? this.props.valores.contId : undefined);
        const planoId = this.props.valores ? this.props.valores.plano_id : undefined;
        if (contId && parseInt(contId) !== 0 && planoId && planoId !== '0' && planoId !== '63' && planoId !== '32') {
          await axiosInstance.get(`/trocaplanos/validar-plano/${contId}/${planoId}`);
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          const message = error.response.data.message;
          toastr.error('Plano Inválido', message);
          return; // Bloqueia a execução
        } else {
          toastr.error('Erro', 'Erro ao validar plano. Tente novamente.');
          return;
        }
      }

      const executaPlanoForcado = async () => {
        // Capturar screenshot apenas uma vez
        let imageLog = null;
        await html2canvas(this.componentRef.current).then(canvas => {
          canvas.style.display = 'none';
          imageLog = canvas.toDataURL('png');
        });

        // Processar anéis selecionados (bitmap)
        const anelBitmap = this.processarAneisSelecionados();
        this.props.valores.grupoFisicoId = this.state.grupoFisicoId;

        console.log('=== FRONTEND DEBUG ===');
        console.log('plano_id:', this.props.valores.plano_id);
        console.log('pf_anel (bitmap):', anelBitmap);
        console.log('contId:', this.props.valores.contId);
        console.log('=====================');

        // Extrair anéis individuais do bitmap
        const aneisParaEnvio = [];
        if (anelBitmap > 0) {
          console.log('=== DEBUG CONVERSÃO BITMAP ===');
          console.log('anelBitmap recebido:', anelBitmap);
          console.log('anelBitmap em binário:', anelBitmap.toString(2).padStart(4, '0'));

          for (let index = 1; index <= 4; index++) {
            const bitmap = Math.pow(2, index - 1);
            const resultado = anelBitmap & bitmap;
            console.log(`Anel ${index}: bitmap=${bitmap}, anelBitmap & bitmap=${resultado}, incluir=${resultado > 0}`);

            if (resultado > 0) {
              aneisParaEnvio.push(index);
            }
          }
          console.log('==============================');
        } else {
          aneisParaEnvio.push(0);
        }

        console.log('=== FRONTEND MULTI ENVIO ===');
        console.log('bitmap calculado:', anelBitmap);
        console.log('bitmaps individuais para envio:', aneisParaEnvio);
        console.log('============================');

        this.setState({ show: true });

        try {
          let todosComSucesso = true;

          // Enviar comandos individuais ao controlador SEM salvar no banco
          for (let i = 0; i < aneisParaEnvio.length; i++) {
            const anelIndividual = aneisParaEnvio[i];
            console.log('=== ENVIANDO ANEL ===');
            console.log('anel individual:', anelIndividual);
            console.log('====================');

            // Criar cópia dos valores sem imageLog para envio ao controlador
            const valoresSemImagem = { ...this.props.valores };
            delete valoresSemImagem.imageLog;
            valoresSemImagem.pf_anel = anelIndividual;

            const result = await this.props.sendForcedSemSalvar(valoresSemImagem);

            if (!result.payload.data.success) {
              todosComSucesso = false;
              break;
            }
          }

          // Se todos os envios foram bem-sucedidos, salvar 1 registro no banco com o bitmap original
          if (todosComSucesso) {
            console.log('=== SALVANDO NO BANCO ===');
            console.log('bitmap original:', anelBitmap);
            console.log('========================');

            // Criar objeto com bitmap original para salvar no banco
            const valoresParaSalvar = {
              ...this.props.valores,
              pf_anel: anelBitmap,
              imageLog: imageLog,
            };

            const resultSalvar = await this.props.sendForced(valoresParaSalvar);

            if (resultSalvar.payload.data.success) {
              this.resetTelaPlanoForcado();
              toastr.success('Sucesso', 'Plano forçado ativado com sucesso.');
            } else {
              toastr.error('Erro', 'Plano ativado no controlador, mas falha ao salvar no banco.');
            }
          } else {
            toastr.error('Erro', 'Falha ao ativar plano forçado em um ou mais anéis.');
          }

          this.setState({ show: false });
        } catch (e) {
          if (e.response && e.response.data && e.response.data.errors) {
            e.response.data.errors.forEach(error =>
              toastr.error('Erro', `Os seguintes controladores: ${error} estão sem conexão`),
            );
          } else {
            toastr.error('Erro', 'Erro ao ativar plano forçado.');
          }
          this.setState({ show: false });
        }
      };

      if (parseInt(window.$('#pf_seleciona_controlador').val()) === 0) {
        swal({
          title: 'Deseja realmente enviar para todos os controladores do Grupo físico?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: 'primary',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          allowOutsideClick: 'false',
        }).then(result => {
          if (result.value) {
            executaPlanoForcado();
          }
        });
      } else {
        executaPlanoForcado();
      }
    }
  }

  // Renderizar card de planos agendados
  renderPlanosAgendados() {
    const { planosAgendados } = this.state;

    if (!planosAgendados || planosAgendados.length === 0) {
      return (
        <div className="plano-forcado-card plano-forcado-empty">
          <div className="card-icon">
            <i className="fa fa-calendar-o" />
          </div>
          <h4>Nenhum Plano Agendado</h4>
        </div>
      );
    }

    return (
      <div className="plano-forcado-card">
        <div className="planos-agendados-list">
          {planosAgendados.map((plano, index) => {
            const anelTexto = this.getAneisTextoPlano(plano);
            const planoDesc = this.getDescricaoPlanoCard(plano);
            const statusTexto = this.getTextoStatusPlano(plano);
            const statusClass = statusTexto === 'Em execução' ? 'status-executando' : 'status-agendado';

            return (
              <div key={index} className="plano-agendado-item">
                <div className="plano-info">
                  <div className="plano-titulo">
                    <i className="fa fa-clock-o" />
                    <strong>{planoDesc}</strong>
                  </div>
                  <div className={`plano-status ${statusClass}`}>{statusTexto}</div>
                  <div className="plano-detalhes">
                    <span className="badge badge-info">{anelTexto}</span>
                    <span className="horario">
                      {plano.horario_inicial} - {plano.horario_final}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    const possuiPlanoForcadoAtivoOuAgendado = this.state.planosAgendados && this.state.planosAgendados.length > 0;

    const requiredSelect = value => (value === '0' || value === undefined ? 'Obrigatório' : undefined);
    const requiredTime = value => (value === undefined ? 'Obrigatório' : undefined);

    return (
      <form onSubmit={handleSubmit} className="plano-forcado-form-premium">
        <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal-load" backdrop={false}>
          <Modal.Body className="modal-body modal-load-body">
            <div>
              <div>
                <ReactLoading className="react-loading" type="spokes" color="#367fa9" height={50} width={50} />
              </div>
              <div>
                <h4>
                  <b>Aguarde, processando...</b>
                </h4>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <div className="plano-forcado-container">
          {/* Card de Configuração */}
          <div className="plano-forcado-section">
            <div className="plano-forcado-card" ref={this.componentRef}>
              <div className="card-body-custom">
                <div className="form-row-premium">
                  <div className="form-group-premium form-group-half">
                    <label className="label-premium">
                      <i className="fa fa-server" /> Grupo Físico
                    </label>
                    <SelectAllGrupoFisico
                      id="pf_seleciona_grupo_fisico"
                      name="pf_seleciona_grupo_fisico"
                      cols="12"
                      hideLabel={true}
                      selectStyle={{ width: '100%' }}
                      onChange={event => {
                        this.setState({ grupoFisicoId: event.target.value, contId: '0' });
                        if (this.props.valores) {
                          this.props.valores.contId = '0';
                        }
                        this.props.getControladorGrupoList(event.target.value);
                        this.carregarPlanosAgendados('0');
                      }}
                      value={this.state.grupoFisicoId}
                    />
                  </div>

                  <div className="form-group-premium form-group-half">
                    <label className="label-premium">
                      <i className="fa fa-hdd" /> Controlador
                    </label>
                    <SelectAllControlador
                      id="pf_seleciona_controlador"
                      name="pf_seleciona_controlador"
                      cols="12"
                      selectStyle={{ width: '100%' }}
                      hideLabel={true}
                      onChange={event => {
                        this.props.valores.contId = event.target.value;
                        this.setState({ contId: event.target.value });
                        this.props.getPlanoList(event.target.value);
                        this.carregarPlanosAgendados(event.target.value);
                      }}
                      value={this.state.contId}
                      data-grupofisico-id={this.state.grupoFisicoId}
                      data-anel-id={1}
                    />
                  </div>
                </div>

                <div className="form-row-premium form-row-plan-time">
                  <div className="form-group-premium form-group-plan">
                    <label className="label-premium">
                      <i className="fa fa-list-alt" /> Plano
                    </label>
                    <SelectPlano
                      id="pf_seleciona_plano"
                      name="pf_seleciona_plano"
                      cols="12"
                      hideLabel={true}
                      selectStyle={{ width: '100%' }}
                      data-controlador-id={this.state.contId}
                      data-plano-piscante={true}
                      validate={requiredSelect}
                      onChange={this.handleChangePlano}
                    />
                  </div>

                  <div className="form-group-premium form-group-half">
                    <label className="label-premium">
                      <i className="fa fa-clock-o" /> Horário Inicial
                    </label>
                    <Field
                      type="time"
                      step="1"
                      component={LabelAndInput}
                      name="horario_inicial"
                      cols="12"
                      hideLabel={true}
                      validate={this.validateMinTime}
                      onBlur={e => this.validateInitialTime(e.target.value)}
                    />
                  </div>

                  <div className="form-group-premium form-group-half">
                    <label className="label-premium">
                      <i className="fa fa-clock-o" /> Horário Final
                    </label>
                    <Field
                      type="time"
                      step="1"
                      component={LabelAndInput}
                      name="horario_final"
                      cols="12"
                      hideLabel={true}
                      validate={requiredTime}
                    />
                  </div>
                </div>

                <div className="form-group-premium">
                  <label className="label-premium">
                    <i className="fa fa-circle-o-notch" /> Anéis
                  </label>
                  <div className="aneis-checkbox-group">
                    <Field
                      cols=""
                      name="anel1"
                      component={Checkbox}
                      label="Anel 1"
                      type="checkbox"
                      disabled={this.state.planoId === '63' || this.state.planoId === '32' ? '' : 'disabled'}
                    />
                    <Field
                      cols=""
                      name="anel2"
                      component={Checkbox}
                      label="Anel 2"
                      type="checkbox"
                      disabled={this.state.planoId === '63' || this.state.planoId === '32' ? '' : 'disabled'}
                    />
                    <Field
                      cols=""
                      name="anel3"
                      component={Checkbox}
                      label="Anel 3"
                      type="checkbox"
                      disabled={this.state.planoId === '63' || this.state.planoId === '32' ? '' : 'disabled'}
                    />
                    <Field
                      cols=""
                      name="anel4"
                      component={Checkbox}
                      label="Anel 4"
                      type="checkbox"
                      disabled={this.state.planoId === '63' || this.state.planoId === '32' ? '' : 'disabled'}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Card de Planos Agendados */}
          <div className="plano-forcado-section">{this.renderPlanosAgendados()}</div>
        </div>
        {possuiPlanoForcadoAtivoOuAgendado && (
          <div style={{ marginBottom: '10px', color: '#000' }}>
            Já existe um plano forçado agendado ou em execução para este controlador. Desative-o antes de ativar outro.
          </div>
        )}
        <div className="plano-forcado-actions">
          <PermissaoUsuario tela="PlanoForcado" condicao={true}>
            <Button
              type="button"
              className="btn-premium btn-primary-premium"
              icon="gavel"
              label="Ativar Plano Forçado"
              disabled={possuiPlanoForcadoAtivoOuAgendado ? 'disabled' : undefined}
              onClick={this.sendForcedPlan}
            />
            <Button
              type="button"
              className="btn-premium btn-warning-premium"
              icon="ban"
              label="Desativar Plano Forçado"
              onClick={this.sendCancelForcedPlan}
            />
          </PermissaoUsuario>
          <PermissaoUsuario tela="PlanoForcado" condicao={false}>
            <Button
              type="button"
              className="btn-premium btn-primary-premium"
              icon="gavel"
              label="Ativar Plano Forçado"
              disabled="disabled"
            />
            <Button
              type="button"
              className="btn-premium btn-warning-premium"
              icon="ban"
              label="Desativar Plano Forçado"
              disabled="disabled"
            />
          </PermissaoUsuario>
        </div>
      </form>
    );
  }
}

PlanoForcadoForm = reduxForm({ form: 'planoForcadoForm', destroyOnUnmount: false })(PlanoForcadoForm);

const mapStateToProps = state => {
  const dados = getFormValues('planoForcadoForm')(state);
  /* não consegui identificar em que momento o valor do campo "pf_seleciona_controlador" é
   * atribuído na propriedade "contId", pois mesmo o uso do setState() no evento
   * change do pf_seleciona_controlador não funciona corretamente
   */
  dados['contId'] = window.$('#pf_seleciona_controlador').val();
  return { valores: dados };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      init,
      sendForced,
      sendForcedSemSalvar,
      sendCancelForced,
      getPlanoList,
      getControladorGrupoList,
      getPlanosAgendados,
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlanoForcadoForm);
